import React, { useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TextField, RadioGroup, Radio, FormControlLabel, FormControl, InputAdornment, IconButton } from "@mui/material";
import clsx from "clsx";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { Col, Row } from "antd";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { idNamingConversion } from "../../../../../helpers/utilities";
import Visibility from "../../../../Shared/components/Icons/Visibility";
import VisibilityOff from "../../../../Shared/components/Icons/VisibilityOff";

export const PosForm = (props) => {
    const { form, error, changeHandler, customObject, getTeamList, posSetup, roleManagement,
        handleSubmit, online = true,
        checkComponentPermission } = props;
    const classes = customStyles();

    const [passwordNewShown, setPasswordNewShown] = useState(false);
    return (
        <Row type="flex" gutter={25} className={clsx(classes.removeUnderline)}>
            <Col span={24}>
                <FormControl
                    className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                    variant={'standard'}
                    fullWidth>
                    <RadioGroup
                        row
                        defaultValue="new-sales"
                        aria-labelledby="demo-customized-radios"
                        name="type"
                        value={form?.type}
                        onChange={(e) => changeHandler(e)}>
                        <FormControlLabel value="Sale" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                            id={idNamingConversion('New Sales', 'storeSales', 'Radio')}
                        />} label="New Sales" />
                        {
                            roleManagement !== '' && checkComponentPermission('Store Sales', 'Action', 'Sales Return') &&
                            <FormControlLabel value="Sale Return" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="Sales Return" />
                        }
                    </RadioGroup>
                </FormControl>
            </Col>
            <Col span={12}>
                <AutoCompleteComponent
                    name={["POS Number ", <span key={"POS Number"} className={classes.colorRedRequired}> *</span>]}
                    heads={[{ 'key': 'posNumber', 'name': 'Number' }]}
                    details={posSetup}
                    id={idNamingConversion('POS Number', 'storeSales', 'DropDown')}
                    parentValue={customObject(posSetup, form.posId)}
                    onChange={(data) => changeHandler(data, 'posId')}
                    position={"bottom"}
                    customClasses={classes.margin20t}
                    parentError={error?.posId}
                />
            </Col>
            <Col span={12}>
                <AutoCompleteComponent
                    name={["User ", <span key={"User"} className={classes.colorRedRequired}> *</span>]}
                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                    details={getTeamList}
                    id={idNamingConversion('User', 'storeSales', 'DropDown')}
                    parentValue={customObject(getTeamList, form.userId)}
                    onChange={(data) => changeHandler(data, 'userId')}
                    position={"bottom"}
                    customClasses={classes.margin20t}
                    parentError={error?.userId}
                />
            </Col>
            {
                form?.userId && online && <Col span={12}>
                    <TextField autoComplete='one-time-code'
                        label={["Password ", <span key={"Password"} className={classes.colorRedRequired}> *</span>]}
                        fullWidth
                        type={passwordNewShown ? "text" : "password"}
                        name="password"
                        id={idNamingConversion('Password', 'storeSales', 'TextField')}
                        className={clsx(classes.margin20t)}
                        error={error?.password && true}
                        helperText={error?.password}
                        variant={'standard'}
                        value={form?.password || ''}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                handleSubmit();
                            }
                        }}
                        InputProps={{
                            classes: {
                                input: classes.textFieldColor
                            },
                            endAdornment: (
                                <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordNewShown(!passwordNewShown)} position="end" >
                                    <IconButton tabIndex={-1}>
                                        {passwordNewShown ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{
                            className: classes.textFieldLableColorCustom
                        }}
                        onChange={(e) => changeHandler(e)}
                    />
                </Col>
            }
        </Row>
    )
}